import { activateFoodsForPortion, deactivateFoods } from './ui-foods.js';

export function hydrateSlider() {
  const sliderPanel = document.getElementById('app-slider-panel');
  sliderPanel?.classList.remove('hidden');
  sliderPanel?.classList.add('visible');

  const slider = document.getElementById('food-slider');
  const display = document.getElementById('slider-display');

  if (!slider || !display) return;

  const updateDisplay = val => {
    const portion = (parseInt(val, 10) / 4).toFixed(2);
    display.textContent = portion;
  };

  // Reset listener on slider
  slider.replaceWith(slider.cloneNode(true));
  const freshSlider = document.getElementById('food-slider');

  freshSlider.addEventListener('input', () => {
    const val = parseInt(freshSlider.value, 10);
    const portion = (val / 4).toFixed(2);
    updateDisplay(val);

    if (val > 0) {
      activateFoodsForPortion(portion);
    } else {
      deactivateFoods();
      resetSlider();
    }
  });

  updateDisplay(freshSlider.value); // initialize display
}

export function resetSlider() {
  const slider = document.getElementById('food-slider');
  const display = document.getElementById('slider-display');
  if (!slider || !display) return;

  slider.value = 0;
  display.textContent = '0.00';
}